import axios from 'axios'
import store from '@/vuex'
import router from '@/router'

function checkPermission(data){
    if(data.result.success==444){
       store.dispatch("doLogout")
       router.push("/login")
       return false;
    }
}

const config={
    baseURL: process.env.VUE_APP_API,
    timeout: 30000
  }


async function post(url,data){
    config['url']=url
    config['headers']={'htkstoken':store.state.user.token,'Content-Type':'application/json'}
    config['method']='post'

    store.commit("LOADING_START")
    const result=await axios.post(url,JSON.stringify(data),config)
    store.commit("LOADING_END")
    checkPermission(result.data)

    return result.data
}


function download(url){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken
  window.location.href=process.env.VUE_APP_API+url+params;
}

function downloadFxBonus(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/yearmonth/"+data.yearmonth
  window.location.href=process.env.VUE_APP_API+url+params;
}

function downloadZsBonus(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/yearmonth/"+data.yearmonth
  window.location.href=process.env.VUE_APP_API+url+params;
}

function downloadSource(url,data){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken+"/mstart/"+data.mstart+"/mend/"+data.mend
  window.location.href=process.env.VUE_APP_API+url+params;
}
function downloadUserCommission(url){
  const excelToken=store.state.user.token
  const params="/token/"+excelToken
  window.location.href=process.env.VUE_APP_API+url+params;
}
export {post,downloadFxBonus,downloadZsBonus,downloadSource,downloadUserCommission,download} 